import { userModel } from 'APP/model/model';
import { IUpdateUserDisplayDataB2B } from 'APP/model/userSettings/userSettingsModel.types';
import Entities from 'STORE';

export async function updateMyProfileB2B(data: IUpdateUserDisplayDataB2B): Promise<boolean> {
  try {
    const response = await userModel.updateProfile({
      nickName: data.nickName,
      phone: data.phone || undefined,
      position: data.position || undefined,
      avatarUrl: data.avatarUrl || undefined,
      firstName: data.firstName || undefined,
      lastName: data.lastName || undefined,
      middleName: data.middleName || undefined,
      displayName: data.displayName,
    });

    Entities.usersStore.Me.updateDisplayData(response);
    return true;
  } catch {
    return false;
  }
}
